// src/components/krums/SaldoWidget.js
import React, { useState, useEffect } from 'react';
import { getSaldo } from '../../services/api';
import { Link } from 'react-router-dom';

const SaldoWidget = () => {
  const [saldo, setSaldo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarSaldo();
    // Actualizar cada 30 segundos
    const interval = setInterval(cargarSaldo, 30000);
    return () => clearInterval(interval);
  }, []);

  const cargarSaldo = async () => {
    try {
      const response = await getSaldo();
      setSaldo(response.data.saldo);
    } catch (error) {
      console.error('Error cargando saldo:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="saldo-skeleton">Cargando...</div>;

  return (
    <div className="saldo-widget">
	  <h3>🔮 Tu Crisol</h3>
      <div className="saldo-item">
        <span className="saldo-icon">⚡</span>
        <span className="saldo-label">Comprados:</span>
        <span className="saldo-valor">{saldo?.krums_comprados || 0}</span>
      </div>
      <div className="saldo-item">
        <span className="saldo-icon">✨</span>
        <span className="saldo-label">Gratis:</span>
        <span className="saldo-valor">{saldo?.krums_gratis || 0}</span>
      </div>
      <div className="saldo-item">
        <span className="saldo-icon">🖼️</span>
        <span className="saldo-label">Imágenes:</span>
        <span className="saldo-valor">{saldo?.imagenes_restantes || 0}</span>
      </div>
	  <div className="saldo-item">
	  	<Link to="/krums" className="btn-ir-tienda">Ir a la tienda</Link>
	  </div>
    </div>
  );
};

export default SaldoWidget;